import { utils, writeFile } from "xlsx";

/**
 * Splits an array into parts based on maxLegnth and function that calculates height based on the content of the array
 * 
 */
export function splitIntoParts<T>(arr: T[], maxLength: number, fn: (arr: T[]) => number): T[][] {
   let part = [arr];
   let i = 0;
   let parIdx = 0;
   if (fn(arr) >= maxLength) {
      part = [[]];
      while (i < arr.length) {
         if (fn([...part[parIdx], arr[i]]) >= maxLength) {
            parIdx++;
            part.push([]);
         }
         part[parIdx].push(arr[i]);
         i++;
      }
      if (parIdx <= 0) return part;
      let minLength = Math.min(3, Math.floor(part[parIdx - 1].length / 2)) - part[parIdx].length;
      console.log("part", part);
      if (minLength > 0) {
         part[parIdx] = [...part[parIdx - 1].splice(-minLength), ...part[parIdx]];
      }
   }
   return part;
}

export function makeAsTableData<T>(arr: T[], fn: (item: object, mainObj: T) => object | undefined, path?: string): any[] {
   if (path) {
      const pathParts = path.split(".");
      return arr.map(item => {
         const mainObj = pathParts.reduce((obj, key) => obj[key], item);
         if (!Array.isArray(mainObj)) {
            console.error("Expected an array at the end of the path, but got:", mainObj);
            return [];
         }
         return mainObj.map((subItem: any) => {
            if (typeof subItem !== "object" || subItem === null) {
               console.error("Expected an object, but got:", subItem);
               return {};
            }
            return fn(subItem, item)
         }) || [];
      }).flat();
   }
   return arr.map(item => {
      if (typeof item !== "object" || item === null) {
         console.error("Expected an object, but got:", item);
         return {};
      }
      return fn(item, item) || {};
   });
}

export function tableToExcel(data: unknown[], filename: string) {
   const worksheet = utils.json_to_sheet(data);
   const workbook = utils.book_new();
   utils.book_append_sheet(workbook, worksheet, "Sheet 1");
   writeFile(workbook, filename);
}

export function aktIdFormat(aktId: string) {
   return aktId.replace(/(.{4})(.{2})(.{2})-()/, "$3.$2.$1-$4")
}